import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Pagination } from 'swiper/modules';
import { useState } from 'react';
import { Link } from 'react-router';
import { Util } from '@/utils/utils';
import type { LayerPopupProps, PopupKind, PopupSlide } from './popup.interface';

const POPUP_COOKIE_KEY: Record<PopupKind, string> = {
	notice: 'layer_popup_notice',
	event: 'layer_popup_event'
};
const renderSlide = (slide: PopupSlide) => {
	const content = slide.isImage ? (
		<div className="popup-banner-image" dangerouslySetInnerHTML={{ __html: slide.content }} />
	) : (
		<div className="popup-banner-text">
			<div dangerouslySetInnerHTML={{ __html: slide.content }} />
		</div>
	);
	if (!slide.link) return content;
	if (/^(https?:)?\/\//i.test(slide.link)) {
		return (
			<a href={slide.link} target={slide.linkTarget} rel="noopener noreferrer" aria-label={slide.alt}>
				{content}
			</a>
		);
	}
	if (/^[a-z][a-z\d+.-]*:/i.test(slide.link)) return content;
	return (
		<Link to={slide.link} target={slide.linkTarget} rel="noopener noreferrer" aria-label={slide.alt}>
			{content}
		</Link>
	);
};

const LayerPopup = ({ type, items = [] }: LayerPopupProps) => {
	const [isClosed, setIsClosed] = useState(false);
	const cookieKey = POPUP_COOKIE_KEY[type];
	const handleHideForWeek = () => {
		Util.setCookie(cookieKey, 'close', 7);
		setIsClosed(true);
	};
	return (
		<section
			className={`popup-banner popup-banner--${type} ${isClosed || items.length === 0 || Util.getCookie(cookieKey) === 'close' ? '' : 'active'}`}
			aria-label={type === 'notice' ? '공지사항 팝업' : '이벤트 팝업'}>
			<Swiper
				modules={[Pagination, Autoplay]}
				spaceBetween={0}
				slidesPerView={1}
				loop={items.length > 1}
				speed={1000}
				autoplay={items.length > 1 ? { delay: 5000, disableOnInteraction: false } : false}
				pagination={{ clickable: true }}>
				{items.map(slide => (
					<SwiperSlide key={slide.id}>{renderSlide(slide)}</SwiperSlide>
				))}
			</Swiper>
			<div className="popup-banner-btns">
				<button type="button" className="popup-banner-btn btn1" onClick={handleHideForWeek}>
					일주일간 보지 않기
				</button>
				<button type="button" className="popup-banner-btn btn2" onClick={() => setIsClosed(true)}>
					닫기
				</button>
			</div>
		</section>
	);
};

export default LayerPopup;
